// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3WlIO","bigColWidth":"Table_bigColWidth__2awX-","biggerColWidth":"Table_biggerColWidth__2vbtx","row":"Table_row__15Xaw","col":"Table_col__2fv5k"};